import React from 'react';
import { Link } from 'react-router-dom';
import { ImagePlaceholder } from '../../../ui/components/media';

const BlogPostCard = ({ article }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <article className="blog-card">
      <Link to={`/blog/${article.id}`} className="blog-card-link">
        <div className="blog-card-image">
          <ImagePlaceholder 
            width="100%"
            height="100%"
            className="blog-image-placeholder"
            text="Blog Image"
          />
        </div>
        
        <div className="blog-card-content">
          <h3 className="blog-card-title">{article.title}</h3>
          <p className="blog-card-excerpt">{article.excerpt}</p>
          <div className="blog-card-meta">{article.readTime} - {formatDate(article.publishDate)}</div>
        </div>
      </Link>
    </article>
  );
};

export default BlogPostCard;
